import { StatusCodeError } from './error/StatusCodeError';

const FILE_BASE_URL = process.env.REACT_APP_FILE_URL;
const FILE_DOWNLOAD_URL = process.env.REACT_APP_DOWNLOAD_URL;

type FilesResponseData = {
    success: string,
    filePath: string,
};

function pathToDownloadURL(filePath: string) {
    return `${FILE_DOWNLOAD_URL}${filePath}`;
}

function files(file: File): Promise<string> {
    const form = new FormData();
    form.append('file', file);

    return fetch(`${FILE_BASE_URL}/files`, {
        method: 'POST',
        body: form,
        credentials: 'omit',
    })
        .then(handleStatusCodeError)
        .then((res) => res.json())
        .then((data: FilesResponseData) => data.filePath);
}

function handleStatusCodeError(response: Response): Response {
    if (!response.ok) {
        throw new StatusCodeError(response);
    }

    return response;
}

export {
    files,
    pathToDownloadURL,
};
